import API from "./axios";

/**
 * Phase 36da.99.gj — Global subscription API.
 *  - status   : every user, on boot, to decide ACTIVE/GRACE/LOCKED
 *  - pay       : admin only — returns { redirectUrl } to send to PhonePe
 *  - verify    : after the PhonePe redirect lands (?orderId=...)
 *  - getConfig / updateConfig / payments : SUPER_ADMIN settings screen
 */
const subscriptionApi = {
  status:       () => API.get("/subscription/status"),
  pay:    (months = 1) => API.post("/subscription/pay", null, { params: { months } }),
  verify: (orderId) => API.get("/subscription/verify", { params: { orderId } }),
  invoice: (orderId) => API.get("/subscription/invoice", { params: { orderId }, responseType: "blob" }),

  getConfig:    () => API.get("/subscription/config"),
  updateConfig: (body) => API.put("/subscription/config", body),
  payments:     () => API.get("/subscription/payments"),
};

export default subscriptionApi;